import { defaultConfig, defineRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

import { menuLinkHoverBase, menuLinkStyle } from './../recipes/link';

export const buttonRecipe = defineRecipe(
    merge(defaultConfig?.theme?.recipes?.button, {
        base: {
            fontWeight: 700,
            borderRadius: 'md',
            focusRingWidth: '2px',
            _focus: {},
            _focusVisible: {
                outlineOffset: '2px',
            },
        },

        defaultVariants: {
            variant: 'outline',
            size: 'md',
        },

        variants: {
            size: {
                sm: {
                    h: 8,
                },
                md: {
                    fontSize: 'md',
                    h: 12,
                },
            },

            variant: {
                surface: {
                    bgColor: 'colorPalette.muted',
                },
                link: {
                    fontWeight: 400,
                    px: 0,
                    py: 0,
                    minW: 0,
                    minH: 0,
                    h: 'auto',
                    color: 'colorPalette.fg',
                    _hover: {
                        textDecoration: 'underline',
                        textUnderlineOffset: '3px',
                        textDecorationColor: 'currentColor/20',
                    },
                },

                plain: {
                    fontWeight: 400,
                },

                linkInvisible: {
                    color: 'inherit',
                    fontSize: '1.125em',
                    minWidth: 0,
                },

                outline: {
                    borderColor: 'colorPalette.solid',
                },

                outlineToSolid: {
                    borderWidth: '1px',
                    '--outline-color-legacy': 'colors.colorPalette.muted',
                    '--outline-color': 'colors.colorPalette.border',
                    borderColor: 'var(--outline-color, var(--outline-color-legacy))',
                    color: 'colorPalette.fg',
                    _hover: {
                        color: 'colorPalette.contrast',
                        bg: 'colorPalette.solid/90',
                    },
                },

                expandableMenuItem: {
                    ...menuLinkStyle,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 4,
                    fontWeight: 'normal',
                    h: 'max-content',
                    borderRadius: 'none',
                    bg: 'white',
                    _hover: {
                        ...menuLinkHoverBase,
                        bg: 'secondary.50',
                    },
                },

                filterItem: {
                    ...defaultConfig?.theme?.recipes?.button?.variants?.outline,
                    color: 'gray.600',
                    borderColor: 'gray.600',
                    bg: 'white',
                    _hover: {
                        bg: 'gray.50',
                    },
                    _active: {
                        bg: 'gray.50',
                    },
                },

                filterItemActive: {
                    ...defaultConfig?.theme?.recipes?.button?.variants?.outline,
                    color: 'white',
                    bg: 'secondary.solid',
                    borderColor: 'secondary.solid',
                    _hover: {
                        bg: 'secondary.700',
                    },
                    _active: {
                        bg: 'secondary.700',
                    },
                },
                outlineBg: {
                    ...defaultConfig?.theme?.recipes?.button?.variants?.outline,
                    color: 'secondary.600',
                    bg: 'white',
                    borderColor: 'secondary.solid',
                    boxShadow: 'sm',
                    fontWeight: 'bold',
                    _hover: {
                        bg: 'secondary.50',
                    },
                    _active: {
                        bg: 'secondary.50',
                    },
                },
                sorting: {
                    ...defaultConfig?.theme?.recipes?.button?.variants?.subtle,
                    gap: 1,
                    fontWeight: 'normal',
                    pr: 3.5,
                    justifySelf: 'center',
                    w: '100%',
                    minW: 'max-content',
                },
            },
        },
    }),
);
